import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import type {
  TenantApiKeysResponse,
  GenerateApiKeyRequest,
  GenerateApiKeyResponse,
} from "./TenantApiKey.model";

export function useTenantApiKeyApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getAll: async () =>
        apiResolver<TenantApiKeysResponse>(api.get("/platform/tenant-api-keys")),
      generate: async (request: GenerateApiKeyRequest) =>
        apiResolver<GenerateApiKeyResponse>(
          api.post("/platform/tenant-api-keys", request),
        ),
      getExploreDocs: async () => {
        const { data } = await api.get<string>("/platform/tenant-api-keys/explore-docs", {
          responseType: "text" as const,
        });
        return data;
      },
    }),
    [api],
  );
}
